<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <h1 class="error-title">Page Not Found</h1>
      <p class="error-message">
        The page you are looking for doesn't exist or has been moved.
      </p>
      <div class="action-buttons">
        <button @click="goToHome" class="btn btn-primary">
          Go to Home
        </button>
        <button @click="goBack" class="btn btn-secondary">
          Go Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goToHome() {
      // Check if user is authenticated
      const userData = JSON.parse(localStorage.getItem("userData"));
      if (userData && userData.token) {
        this.$router.push("/dashboard");
      } else {
        this.$router.push("/");
      }
    },
    goBack() {
      // Go back if there's history, otherwise go to home
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.goToHome();
      }
    }
  }
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(146deg, #000000CC 35%, #3A2A00DE 77%);
  padding: 20px;
}

.not-found-content {
  text-align: center;
  max-width: 600px;
  background: rgba(255, 255, 255, 0.95);
  padding: 60px 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.error-code {
  font-size: 120px;
  font-weight: 700;
  color: #c09a07;
  line-height: 1;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.error-title {
  font-size: 32px;
  font-weight: 600;
  color: #080808;
  margin-bottom: 16px;
  font-family: sansation;
}

.error-message {
  font-size: 18px;
  color: #616161;
  margin-bottom: 40px;
  line-height: 1.6;
}

.action-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn:active {
  transform: translateY(0);
}

.btn-primary {
  background-color: #c09a07;
  color: #f0f0f0;
}

.btn-primary:hover {
  background-color: #9e800d;
  color: #f0f0f0;
}

.btn-secondary {
  background-color: #d3d3d3;
  color: #080808;
}

.btn-secondary:hover {
  background-color: #b8b8b8;
  color: #080808;
}

@media (max-width: 768px) {
  .not-found-content {
    padding: 40px 24px;
  }

  .error-code {
    font-size: 80px;
  }

  .error-title {
    font-size: 24px;
  }

  .error-message {
    font-size: 16px;
  }

  .action-buttons {
    flex-direction: column;
    width: 100%;
  }

  .action-buttons .btn {
    width: 100%;
  }
}
</style>
